import React from 'react';

import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useSendDoubledDomainNameVerificationEmailMessageMutation } from '@dashboard/generated/wp/administrator';
import { Button } from '@mui/material';

type Props = {
  id: string;
};
export default function SendDoubledDnsEmailButton({ id }: Props) {
  const [executeMutation, { loading }] = useSendDoubledDomainNameVerificationEmailMessageMutation();
  const onClick = async () => {
    const confirmed = window.confirm('Are you sure you want to send the doubled DNS email?');
    if (!confirmed) return;

    await executeMutation({ variables: { id } });
    alertSuccess('Doubled DNS email sent');
  };

  return (
    <Button variant="outlined" disabled={loading} type="button" onClick={onClick}>
      Send doubled DNS email
    </Button>
  );
}
